import React, { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { format, eachDayOfInterval, startOfMonth, endOfMonth, eachMonthOfInterval } from "date-fns";
import { DefaultLayout } from "../../../../layouts/Default";
import { TopNavigation } from "../../../../themes/Default/components/TopNavigation";
import { Title } from "../../../../themes/Default/components/Title";
import { Main } from "../../../../themes/Default/components/Main";
import { Tabs } from "../../../../themes/Default/components/Tabs";
import { ButtonBack} from "../../../../themes/Default/components/TopNavigation/components/Button";
import { Calendar } from "../../../../themes/Default/components/Calendar";
import { Month } from "../../../../themes/Default/components/Calendar/components/Month";
import { Day, DayOffset } from "../../../../themes/Default/components/Calendar/components/Month/components/Day";
import { groupsManagement } from "../../../../hooks/api/GroupsManagement";
import { useTranslation } from "react-i18next";
import { Slide, toast, ToastContainer } from "react-toastify";
import { calendarHolidaysManagement } from "../../../../hooks/api/CalendarHolidaysManagement";
import { Toaster } from "../../../../themes/Default/components/Toaster";

const CancelClass = () => {
    const navigate = useNavigate();
    const { t } = useTranslation("common");
    const [dates, setDates] = useState([]);
    const [totalSelectedDates, setTotalSelectedDates] = useState([]);
    const [classNumber, setClassNumber] = useState([]);
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const { groupId } = useParams();
    const { dateId } = useParams();
    const [months, setMonths] = useState([]);
    const {  useListGroupDatesMutation, useViewGroupDateMutation, useViewGroupMutation, useCancelClassMutation } = groupsManagement;

    const [listGroupDates] = useListGroupDatesMutation();
    const [viewGroupDate] = useViewGroupDateMutation();
    const [viewGroup] = useViewGroupMutation();
    const [holidays, setHolidays] = useState();
    const { useCalendarHolidaysListMutation } = calendarHolidaysManagement;
    const [holidayList] = useCalendarHolidaysListMutation();

    const [cancelClass] = useCancelClassMutation();
    const [classStartTime, setClassStartTime] = useState([]);
    const [classEndTime ,setClassEndTime] = useState([]);

    const onSave = (newDateId, date) => {
        viewGroupDate({ dateId: newDateId, groupId }).then((result) => {
            if (result?.data?.id) {
            } else {
                toast.warn(
                    ({ closeToast }) => (
                        <Toaster
                            closeToast={closeToast}
                            description={t("groups.confirmCancelClass")}
                            optionNo={t("no")}
                            optionYes={t("yes")}
                            onClick={() => {
                                closeToast();
                                const body = {
                                    date: date,
                                    timeFrom: classStartTime,
                                    timeTo: classEndTime,       
                                };
                                cancelClass({ body, groupId, cancelCalendarId: dateId }).then((result) => {
                                    if (result?.error) {
                                        toast.error(result?.error?.data?.error?.responseMessage);
                                    } else {
                                        navigate("/groups/" + groupId + "/attendance");
                                    }
                                });
                            }}
                        />
                    ),
                    {
                        autoClose: false,
                        progress: false,
                        closeButton: false,
                    },
                );
            }
        });
    };

    const isCancel = (dateId) => {
        return dates.some(date => date.id === dateId && date.isCancel === true);
    }

    const monthNames = [
        t("calendar.january"),
        t("calendar.february"),
        t("calendar.march"),
        t("calendar.april"),
        t("calendar.may"),
        t("calendar.june"),
        t("calendar.july"),
        t("calendar.august"),
        t("calendar.september"),
        t("calendar.october"),
        t("calendar.november"),
        t("calendar.december"),
    ];

    const loadMonths = () => {
        listGroupDates(groupId).then((result) => {
            setDates(result?.data?.records);
            const months = eachMonthOfInterval({
                start: startOfMonth(startDate),
                end: endOfMonth(endDate),
            });
            setMonths(months);
            setTotalSelectedDates(result?.data?.totalRecords);
        });
    };

    const loadGroupName = () => {
        viewGroup(groupId).then((result) => {
            setClassNumber(result?.data?.classNumber);
            setStartDate(result?.data?.startDate ? new Date(result.data.startDate) : new Date("2025-01-01"));
            setEndDate(result?.data?.endDate ? new Date(result.data.endDate) : new Date("2025-12-31"));

            setClassStartTime(result?.data?.classStartTime);
            
            const [hours, minutes] = result?.data?.classStartTime.split(':').map(Number);
            const now = new Date();
            now.setHours(hours, minutes, 0, 0); 

            const endDate = new Date(now.getTime() + result?.data?.classDuration * 60000);

            const endHours = endDate.getHours().toString().padStart(2, '0');
            const endMinutes = endDate.getMinutes().toString().padStart(2, '0');
            const endTime = `${endHours}:${endMinutes}`;
            setClassEndTime(endTime);
        });
    };

    const checkHoliday = (selectedDate) => {
        const holiday = holidays.find((holiday) => holiday.date === selectedDate);
    
        if (holiday) {
            toast.error(
                <>
                    Izabrali ste praznik <br />
                    {holiday.title}
                </>
            );
            return true;
        }
    
        return false;
    };

    useEffect(() => {
        loadGroupName();
    }, []);

    useEffect(() => {
        if (startDate) {
            loadMonths();
        }
    }, [startDate]);

    useEffect(() => {
        holidayList().then((result) => {
            const holidays = result?.data?.records;
            setHolidays(holidays);
        });
    }, [holidayList]);


    return (
        <DefaultLayout>
            
            <TopNavigation>
                <ButtonBack to={"/groups/"+ groupId +"/attendance"} />
            </TopNavigation>
            <Tabs  />
            <Main>
                <Title fullWidth={"100%"}>
                    Izaberite zamenski cas
                    <span className="numOfClasses">
                        {t("groups.classNumber")}:{" "}
                        <span className="numOfClassesFrstNum" style={totalSelectedDates !== classNumber ? { color: "#EB5757" } : {}}>
                            {totalSelectedDates}
                        </span>
                        <span className="numOfClassesScndNum">/{classNumber}</span>
                    </span>
                </Title>
                <Calendar>
                    {months.map((month, index) => {
                        const days = eachDayOfInterval({
                            start: startOfMonth(month),
                            end: endOfMonth(month),
                        });

                        return (
                            <Month month={monthNames[month.getMonth()]} year={month.getFullYear()} key={index}>
                                <DayOffset days={days} />
                                {days.map((day, index) => {
                                    let isWeekend = day.getDay() === 6 || day.getDay() === 0;
                                    let isSelected = dates.some((item) => item.date === format(day, "yyyy-MM-dd"));

                                    const selectedItem = dates.find((item) => item.date === format(day, "yyyy-MM-dd"));
                                    const dateId = selectedItem ? selectedItem.id : 0;
                                    const isCanceled = isCancel(dateId);
                                    return (
                                        <Day
                                            key={index}
                                            isWeekend={isWeekend}
                                            isSelected={isSelected}
                                            isCanceled={isCanceled}
                                            value={format(day, "d")}
                                            onClick={() => {
                                                if (!checkHoliday(format(day, "yyyy-MM-dd"))) {
                                                    onSave(dateId, format(day, "yyyy-MM-dd"));
                                                }
                                            }}
                                        />
                                    );
                                })}
                            </Month>
                        );
                    })}
                </Calendar>
            </Main>
        </DefaultLayout>
    );
};

export default CancelClass;
